// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @26.11.2021 13:31:14
import { CVehicleHistory_abstract } from './../../abstract/SagaSchema/History/CVehicleHistory_abstract';

export class CVehicleHistory extends CVehicleHistory_abstract {}
